<template>
    <section class="py-0 bg-1000">

        <div class="container">
          <div class="row justify-content-md-between justify-content-evenly py-4">
            <div class="col-12 col-sm-8 col-md-6 col-lg-auto text-center text-md-start">
              <p class="fs--1 my-2 fw-bold text-200">All rights Reserved &copy; eCampuz, 2022</p>
            </div>
            <div class="col-12 col-sm-8 col-md-6">
              <p class="fs--1 my-2 text-center text-md-end text-200"> Made by&nbsp;<a class="fw-bold text-white" href="https://www.ecampuz.com" target="_blank"> eCampuz</a>
              </p>
            </div>
          </div>
        </div>
        <!-- end of .container-->

      </section>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      userIP: '',
    };
  },
  mounted() {
    this.getUserIP();
  },
  methods: {
    async getUserIP() {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        this.userIP = data.ip;
        this.trackActivity(window.location.href);
      } catch (error) {
        console.error('Error fetching IP:', error);
      }
    },

    detectBrowserAndDevice() {
      const ua = navigator.userAgent;
      let browser = "Unknown";

      if (/samsungbrowser/i.test(ua)) {
        browser = 'Samsung Internet';
      } else if (/crios/i.test(ua)) {
        browser = 'Chrome (iOS)';
      } else if (/fxios/i.test(ua)) {
        browser = 'Firefox (iOS)';
      } else if (/chrome/i.test(ua) && /android/i.test(ua)) {
        browser = 'Chrome (Android)';
      } else if (/chrome/i.test(ua) && !/edg|opr|brave|fxios|crios/i.test(ua)) {
        browser = 'Google Chrome';
      } else if (/duckduckgo/i.test(ua)) {
        browser = 'DuckDuckGo';
      } else if (/opera mini/i.test(ua)) {
        browser = 'Opera Mini';
      } else if (/ucbrowser/i.test(ua)) {
        browser = 'UC Browser';
      } else if (/brave/i.test(ua)) {
        browser = 'Brave';
      } else if (/edg/i.test(ua)) {
        browser = 'Microsoft Edge';
      } else if (/opr|opera/i.test(ua)) {
        browser = 'Opera';
      } else if (/safari/i.test(ua) && /mobile/i.test(ua) && !/crios|fxios|chrome|opr|edg/i.test(ua)) {
        browser = 'Mobile Safari';
      } else if (/safari/i.test(ua)) {
        browser = 'Safari';
      } else if (/firefox/i.test(ua)) {
        browser = 'Mozilla Firefox';
      } else if (/msie|trident/i.test(ua)) {
        browser = 'Internet Explorer';
      }

      const isMobile = /Mobi|Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini|Windows Phone|Kindle|Silk|Mobile/i.test(ua);
      const device = isMobile ? 'mobile' : 'laptop';

      return { browser, device };
    },

    trackActivity(url) {
      const { browser, device } = this.detectBrowserAndDevice();

      const activity = {
        url: url,
        date: new Date().toISOString(),
        ip: this.userIP,
        device: device,
        userAgent: browser,
        description: '',
        referrer: document.referrer,
        source: 'landing_page',
      };

      fetch(`${process.env.VUE_APP_URL_SERVICE}/mqtt/publish`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(activity),
      })
        .then(response => response.json())
        .then(data => console.log("Activity sent:", data))
        .catch(error => console.error("Error sending activity:", error));
    },

    handleLinkClick(url) {
      this.trackActivity(url);
      setTimeout(() => {
        window.location.href = url;
      }, 300);
    }
  },
};
</script>